/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { DEBI_STATUS_LABEL, MAINTENANCE_DC_LABEL } from '../../../utils/constants/GlobalConstants';

export default function DropDown(props) {
  const [data, setData] = React.useState(props.data)
  const [item, setItem] = React.useState(props.label === MAINTENANCE_DC_LABEL ? props.selectedDCIndex : props.label === DEBI_STATUS_LABEL ? 1 : '');
  const [multiItem, setMultiItem] = React.useState([])

  useEffect(() => {
    setData(props.data);
  }, [props])

  useEffect(() => {
    if (props.selectedDCIndex !== undefined) {
      setItem(props.selectedDCIndex)
    }
  }, [props.selectedDCIndex])

  useEffect(() => {
    if (item && props.label === MAINTENANCE_DC_LABEL) {
      setItem("")
    }
  }, [props.resetDropdown])

  const handleChange = (event) => {
    setItem(event.target.value);
    let valSelected = props.label === MAINTENANCE_DC_LABEL ? data[event.target.value]?.label : data[event.target.value - 1]?.label;
    props.valSelectedFromDropDown(valSelected);
  }
  const handleMultiChange = (event) => {
    const ids = event.target.value;
    setMultiItem(ids);
    let valSelected = data.filter(item => ids.includes(item.distributionCenterId)).map(item => item.distributionCenterName);
    props.valSelectedFromDropDown(valSelected);
  }
  return (
    <FormControl sx={{ width: '100%' }} size="small">

      {!props.hasMultiple && (<><InputLabel id="demo-select-small-label">{props.label}</InputLabel><Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={item}
        label={props.label}
        onChange={handleChange}

      >
        {data && data.map((rowItem, index) => {

          return (
            <MenuItem sx={{ width: "495px !important" }} key={index} name={rowItem.label} value={rowItem.id}>{rowItem.label}</MenuItem>
          )
        })}
      </Select></>)}
      {props.hasMultiple && (<>
      <InputLabel id="demo-select-label">{props.label}</InputLabel>
        <Select
          multiple
          labelId="demo-select-label"
          id="demo-select"
          testid="select"
          value={multiItem}
          label={props.label}
          onChange={handleMultiChange}
          disabled={props.disabled}
        >
          {data && data.map((rowItem, index) => {

            return (
              <MenuItem sx={{ width: "495px !important" }} key={index} name={rowItem.distributionCenterName} value={rowItem.distributionCenterId}>{rowItem.distributionCenterName}</MenuItem>
            )
          })}
        </Select></>)}
    </FormControl>
  );
}
